import rollbar from '#services/rollbar';

const MAX_BUFFERED = 25;
const recentViolations = [];

let installed = false;

function summarize(e) {
  return {
    blockedURI: e.blockedURI,
    violatedDirective: e.violatedDirective,
    effectiveDirective: e.effectiveDirective,
    disposition: e.disposition,
    sourceFile: e.sourceFile,
    lineNumber: e.lineNumber,
    documentURI: e.documentURI,
    timestamp: new Date().toISOString(),
  };
}

const STRIPE_HOST_RE = /stripe\.(com|network)/i;

/**
 * Start listening for CSP violations. Every block (e.g. a Stripe endpoint
 * missing from connect-src) is buffered so other code — like the checkout
 * confirmPayment watchdog — can attach "what was blocked" to its own report.
 * Stripe-related blocks are also reported to Rollbar immediately, since those
 * are the ones that silently stall payments.
 */
export function installCspViolationCapture() {
  // Best-effort, never throw: this runs at app bootstrap before render, so a
  // failure here must not take down the app.
  try {
    if (installed || typeof document === 'undefined') return;
    installed = true;

    document.addEventListener('securitypolicyviolation', (e) => {
      try {
        const v = summarize(e);
        recentViolations.push(v);
        if (recentViolations.length > MAX_BUFFERED) recentViolations.shift();

        if (STRIPE_HOST_RE.test(e.blockedURI || '')) {
          rollbar.error('CSP blocked a Stripe request', v);
        }
      } catch {
        // Swallow — diagnostics must never affect the page.
      }
    });
  } catch {
    // Swallow — diagnostics must never affect the page.
  }
}

/** Return a copy of the buffered CSP violations (most recent last). */
export function getRecentCspViolations() {
  return recentViolations.slice();
}
